module.exports = __webpack_public_path__ + "img/bg.d95ca311.png";